import { CredentialType } from "@api/shared-runtime/enums";
import { summaryState } from "@/features/credentials/components/credential-card/credential-details/credential-summary-values";
import type { Credential } from "@/features/credentials/types";

export function ProfileStateLicenses({
  credentials,
}: {
  credentials: Credential[];
}) {
  const states = new Map<string, string>();
  for (const credential of credentials) {
    if (
      !credential.present ||
      credential.credentialType !== CredentialType.StateLicense
    ) {
      continue;
    }
    const state = summaryState(credential.version?.stateCode);
    if (state) {
      states.set(state.toLowerCase(), state);
    }
  }
  if (states.size === 0) {
    return null;
  }

  return (
    <ul
      aria-label="State licenses"
      className="flex w-full min-w-0 flex-wrap gap-1.5"
    >
      {[...states.entries()].map(([key, state]) => (
        <li
          key={key}
          className="max-w-full rounded-lg border border-slate-200 bg-slate-50 px-2 py-1 text-xs font-medium text-slate-600 [overflow-wrap:anywhere]"
        >
          {state}
        </li>
      ))}
    </ul>
  );
}
